import { useSelector } from 'react-redux';
import Header from '../components/Header';
import MetaPixel from '../components/MetaPixel';
import { CoverIsFor } from '../types/types';
import { useEffect } from 'react';
import MobileProgressBar from '../components/MobileProgressBar';

interface Props {
  children: React.ReactNode;
}

function MultiStepFormLayout({ children }: Props) {
  const { isMobileView } = useSelector((state: any) => state.viewport);
  const { formData, currentStep } = useSelector(
    (state: any) => state.formRegistration,
  );

  const getCurrentStep = () => {
    if (
      CoverIsFor.SingleParentFamily === formData.coverIsFor ||
      CoverIsFor.Family === formData.coverIsFor
    ) {
      switch (currentStep) {
        case 0:
          return 1;
        case 1:
          return 2;
        case 2:
          return 3;
        case 3:
          return 4;
        case 4:
          return 5;
        case 5:
          return 6;
        case 6:
          return 6;
        case 7:
          return 7;
        case 8:
          return 8;
        default:
          return 0;
      }
    } else {
      switch (currentStep) {
        case 0:
          return 1;
        case 1:
          return 2;
        case 2:
          return 3;
        case 3:
          return 4;
        case 4:
          return 4;
        case 5:
          return 6;
        case 6:
          return 5;
        case 7:
          return 6;
        case 8:
          return 7;
        default:
          return 0;
      }
    }
  };

  useEffect(() => {
    // Load the Trustpilot widget script
    const script = document.createElement('script');
    script.src =
      'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  if (isMobileView) {
    return (
      <div className="w-full h-full bg-[white]">
        <MetaPixel />
        <Header />
        <div className="flex flex-col w-full">
          <MobileProgressBar />
          <div className="p-[15px] w-full bg-[white] flex flex-col">
            {children}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-full bg-[white]">
      <MetaPixel />
      <Header />
      <div className="flex flex-col w-full items-center">
        <MobileProgressBar />
        <div className="p-[15px] w-1/2 bg-[white] flex flex-col items-center justify-center">
          <div className=" w-full bg-[white] flex flex-col">
            <span className="text-[#CD232E] text-[12px] text-start">
              Step {getCurrentStep()} of{' '}
              {[CoverIsFor.SingleParentFamily, CoverIsFor.Family].includes(
                formData.coverIsFor,
              )
                ? 8
                : 7}
            </span>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}

export default MultiStepFormLayout;
